module.exports = __webpack_public_path__ + "static/media/flag-popup-footer.573d8b14.png";